module.exports = __webpack_public_path__ + "img/img-710da6.png";